import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";
import { TextDiffAPI } from "../../Services/APIService";
import { exampleParagraph } from "../../Services/Tools";

function TextDifferece() {
    const navigate = useNavigate();
    const location = useLocation();

    const [baseText, setBaseText] = useState("");
    const [inputs, setInputs] = useState([""]);

    const toolFav = { toolName: "Text Diff", Iconpath: "/GitDiffRaw.svg" };

    

    useEffect(() => {
        if (location.state?.baseText && location.state?.inputs) {
            setBaseText(location.state.baseText);
            setInputs(location.state.inputs);
        }
    }, [location.state]);


    

    const addInput = () => {
        if (inputs.length >= 3) return;
        setInputs([...inputs, ""]);
    };

    const removeInput = (index) => {
        if (inputs.length === 1) return; // prevent removing last one
        const updated = inputs.filter((_, i) => i !== index);
        setInputs(updated);
    };

    const updateInput = (index, value) => {
        const updated = [...inputs];
        updated[index] = value;
        setInputs(updated);
    };


    const pasteExample = (type, index) => {
        const example =exampleParagraph;
        if (type === "base") setBaseText(example);
        else updateInput(index, example);
    };

    const computeDiff = async () => {
        if (!baseText.trim() || inputs.length === 0) return;

        try {
            const compareWith = inputs.filter(i => i !== "" && i.trim());
            const payload = {
                baseText: baseText,
                compareWith
            };

            const response = await TextDiffAPI(payload);
            const apiData = response?.data;

            if (!apiData) return;

            navigate("/text-diff-view", {
                state: {
                    baseText,
                    validInputs: compareWith,
                    comparisons: apiData.comparisons || {}
                }
            });
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <Col className="json-multi-diff-page">
            {/* HEADER */}
            <ToolHeader title="Text Diff" description="Compare a base text with multiple text inputs" toolFav={toolFav} />

            {/* BASE TEXT */}
            <Row className="Formatter">
                <FormatterPanel
                    title="Base text"
                    value={baseText}
                    onChange={(e) => setBaseText(e.target.value)}
                    placeholder="Paste base text here..."
                    lineCount={baseText!== "" ?baseText.split("\n").length:0}
                    panelStyle={{ width: "100%", height: "250px" }}
                    headerButtons={
                        <InputHeaderButtons
                            primaryLabel="Example"
                            onPrimary={() => pasteExample("base")}
                            onClear={() => setBaseText("")}
                            onImport={(file) => setBaseText(file)}
                        />
                    }
                    footerLeft={`Characters : ${baseText.replaceAll(" ", "").length}`}
                    footerRight={`Size : ${new Blob([baseText]).size} B`}
                />
            </Row>

            {/* âœ… GRID INPUTS */}
            <Row
                className="multi-input-grid"
                style={{
                    gridTemplateColumns: `repeat(${inputs.length}, 1fr)`
                }}
            >
                {inputs.map((input, index) => (
                    <div key={index} className="grid-item">
                        <FormatterPanel
                            title={`Text ${index + 1}`}
                            value={input}
                            onChange={(e) => updateInput(index, e.target.value)}
                            placeholder="Paste text here..."
                            lineCount={input!== "" ?input.split("\n").length:0}
                            panelStyle={{ height: "250px", width: "inherit" }}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={() => pasteExample("input", index)}
                                    onClear={() => updateInput(index, "")}
                                    onImport={(file) => updateInput(index, file)}
                                    accept=".txt"
                                    onRemove={() => removeInput(index)}
                                    showRemove={inputs.length > 1}
                                />
                            }
                            footerLeft={`Characters : ${input.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([input]).size} B`}
                        />
                    </div>
                ))}
            </Row>

            <Row>
            {inputs.length < 3 && <Col className="add-json-btn" onClick={addInput}>
                + Add Text to compare
            </Col>}
            </Row>

            {/* BOTTOM BAR */}
            
            <Row className="bottom-bar">
                <Col>
                <span>
                    Comparing Base Text with {inputs.filter(i => i.trim()).length} input{inputs.filter(i => i.trim()).length !== 1 ? "s" : ""}
                </span>
                </Col>
                <Col>
                <button className="compare-btn" onClick={computeDiff}>
                    Compare
                </button>
                </Col>
            </Row>
             
        </Col>
    );
}

export default TextDifferece;
